"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const RequiredFieldMarker = ({ tooltipMessage }) => (react_1.default.createElement(Tooltip_1.default, { content: tooltipMessage },
    react_1.default.createElement("span", { className: "px-1", "aria-label": "Required field" }, "*")));
exports.default = RequiredFieldMarker;
